<template>
  <div ref="thisRef" v-clickOutside="save" class="relative">
    <div
      class="border-b-3 border-app-color pb-10 mb-20"
    >
      <div class="flex justify-between items-center">
        <input
          ref="inputRef"
          v-model="title"
          class="font-Inter text-19 font-bold leading-small bg-transparent outline-none pr-15 h-26 flex-grow"
          type="text"
          maxlength="18"
          @keypress.enter="save"
        >
        <NewTaskRowColor position="right-10" :color="color" @updateColor="updateColor" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import NewTaskRowColor from './NewTaskRowColor.vue'

export default defineComponent({
  components: { NewTaskRowColor },

  props: {
    bookId: Number
  },

  emits: ['close'],

  setup (props, { emit }) {
    const { getters, dispatch } = useStore()

    const inputRef = ref(null)
    const thisRef = ref(null)

    const title = ref('New column')
    const color = ref(6250495)

    const isMobile = computed(() => getters.isMobile)
    const isDarkMode = computed(() => getters.isDarkMode)
    const isTwilightTheme = computed(() => getters.isTwilightTheme)
    const isMagenta = computed(() => getters.isMagenta)

    onMounted(() => {
      nextTick(() => {
        if (inputRef.value) {
          thisRef.value.scrollIntoView({ behavior: 'smooth' })
          inputRef.value.focus()
          inputRef.value.setSelectionRange(0, 9999)
        }
      })
    })

    function save () {
      if (title.value.trim() !== '') {
        dispatch('createRow', {
          title: title.value.trim().slice(0, 28),
          color: color.value,
          bookId: props.bookId
        })
      }
      emit('close')
    }

    function updateColor (value) {
      color.value = value
    }

    return {
      // refs
      inputRef,
      thisRef,
      // data
      title,
      color,
      // computed
      isMobile,
      isDarkMode,
      isMagenta,
      isTwilightTheme,
      // functions
      save,
      updateColor
    }
  }
})
</script>
